import Theme from './theme';
import { USER_AGENT, CNB_TYPE, AREA_TYPE, STATIC_DOMAIN_MAP, DOWNLOAD_PLATFORM, PLATFORM, PURPLE_SCHEME, DEVICE } from './const';
import { setLnbData } from './LnbCommon';

let singleton = null;
let singletonEnforcer = 'singletonEnforcer';

export default class Common {
    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) throw 'Cannot--construct singleton';
    }

    static get instance() {
        if (!singleton) singleton = new Common(singletonEnforcer);
        return singleton;
    }

    init() {
        this.__platform = this.getPlatform();
        this.__device = this.getDevice();
        this.__isMobile = this.__device === DEVICE.MOBILE.key;
        this.__country = document.querySelector('html')?.dataset?.country?.toLocaleUpperCase() || 'NC';

        this.__rcDash = '';
        this.__rc2Dash = '';
        if (/(rc\.|rc\-)/i.test(location.href)) {
            this.__rcDash = 'rc-';
            this.__rc2Dash = 'rc2-'
        }

        this.__config = {
            type: '',
            area: AREA_TYPE.NCK, // 권역 타입 (2023.06.01 신규 추가)
            bi: {},
            useLeftMenu: true,
            useJoinMenu: true,
            useLoginMenu: true,
            useNotice: true,
            joinURL: `https://${this.__rcDash}login.plaync.com/nclogin/signup`,
            serviceList: {
                isServiceShow: true,
                isGamesShow: true,
                services:{
                    "Plaync": {
                        "isShow": true,
                        "url": `https://${this.__rcDash}www.plaync.com/`
                    },
                    "NShop": {
                        "isShow": true,
                        "url": `https://${this.__rcDash}nshop.plaync.com/`
                    }
                }
            }
        };
    }

    set config(_config) {
        this.__config = jQuery.extend(true, {}, this.__config, _config);
        this.__config.type = (this.__config.type || this.__config.cnbType || '').toUpperCase();
        this.__config.userData = jQuery.extend(true, {}, { accountState: { case: 0, msg: '' } }, window.userData);

        switch (this.__config.type) {
            case CNB_TYPE.A:
                break;
            case CNB_TYPE.B:
                this.__config.useJoinMenu = false;
                this.__config.lnbList = [];
                this.__config.search = {isShow: false};
                this.__config.useGameStart = false;
                break;
            case CNB_TYPE.D:
                this.__config.lnbList = [];
                this.__config.header = {};
            case CNB_TYPE.C:
                this.__config.header = {};
                this.__config.search = {isShow: false};
                this.__config.useGameStart = false;
                break;
            case CNB_TYPE.PURPLE:
                const isPurpleLauncher = this.purpleCheck.isPurpleLauncher;
                if(isPurpleLauncher) {
                    this.__config.useLeftMenu = false;
                    this.__config.useNotice = false;
                    this.__config.useCs = false;
                    this.__config.serviceList = {
                        isServiceShow: false,
                        isGamesShow: false
                    };
                    this.__config.shortCut = {isShow: false};
                    this.__config.search = {isShow: false};
                }
                
                this.__config.useJoinMenu = false;                
                this.__config.useLoginMenu = true;                
                this.__config.useGameStart = false;
                this.__config.goPurpleErrorPageInCnb = this.__config.goPurpleErrorPageInCnb || false;
                
        }

        // 퍼플 모바일앱(인앱)일 때, 게임리스트 숨김
        if(this.purpleCheck.isPurpleApp) {
            this.__config.serviceList = {...this.__config.serviceList, isServiceShow: false, isGamesShow: false};
        }

        // lnbData에 사용한 onClick 콜백 옵션값을 lnbCallbackMap에 저장함
        if(Array.isArray(this.__config.lnbData)) {
            const { newLnbData, callbackMap } = setLnbData(this.__config.lnbData) || {};
            this.__config.lnbData = newLnbData;
            this.__config.lnbCallbackMap = callbackMap;
        }

        // userGameStart === 'platformDownload'이면서 platformDownload 속성 있을 때
        const { useGameStart, platformDownload } = this.__config;
        if(useGameStart === 'platformDownload' && Array.isArray(platformDownload)) {
            this.__config.platformDownload = this.setPlatformDownloadData(platformDownload);
        }

        // 2023.03.08 - 캐릭터 정보 중 "서버"만 노출하도록 수정됨 (고객지원 이동경로 개선건)
        const { useCharInfoOnlyServer } = this.__config;
        if(typeof useCharInfoOnlyServer !== 'boolean') {
            this.__config.useCharInfoOnlyServer = true;
        }

        // nshop popup.min.js 사용 여부 (cnb 내부에서만 사용)
        this.__config.useNshopPopup = this.__config.type !== CNB_TYPE.PURPLE;

        // set theme...
        if (typeof this.__theme === 'undefined') {
            this.__theme = new Theme();
        }
        this.__theme.update(this.__config);
    }

    get config() {
        return this.__config;
    }

    get theme() {
        return this.__theme;
    }
    get staticHost() {
        return this.__staticHost;
    }

    get isMobile() {
        return this.__isMobile;
    }

    get platform() {
        return this.__platform;
    }

    get device() {
        return this.__device;
    }

    get env() {
        return this.__env;
    }

    set l10nData(_data){
        this.__l10nData = _data;
    }

    get l10nData(){
        return this.__l10nData;
    }

    get country(){
        return this.__country;
    }

    get rcDash(){
        return this.__rcDash;
    }

    getPlatform() {
        const ua = navigator.userAgent.toLowerCase();
        const entries = Object.entries(USER_AGENT);
        let platform = null;
        
        entries?.some(v => {
            const uaArr = v[1] || [];
            const filterUa = uaArr.filter(uaValue => ua.includes(uaValue));
            
            if(filterUa?.length > 0) {
                platform = v[0];
                return true;
            }

            return false;
        });

        return platform || PLATFORM.PC_WEB;
    }

    getDevice() {
        const platform = this.__platform;
        const deviceEntries = Object.entries(DEVICE);
        let device = null;

        deviceEntries?.some(v => {
            const deviceInfo = v[1] || {};
            if(deviceInfo?.platform?.includes(platform)) {
                device = deviceInfo?.key;
                return true;
            }

            return false;
        });

        return device;
    }

    get purpleCheck() {
        const isPurple = Object.values(PLATFORM.PURPLE)?.includes(this.platform);
        const isPurpleLauncher = this.platform === PLATFORM.PURPLE.LAUNCHER;
        const isPurpleInApp = this.platform === PLATFORM.PURPLE.INAPP;
        const isPurpleWebview = this.platform === PLATFORM.PURPLE.WEBVIEW;
        const isPurpleApp = isPurpleInApp || isPurpleWebview;

        return {
            isPurple,
            isPurpleLauncher,
            isPurpleInApp,
            isPurpleWebview,
            isPurpleApp
        };
    }

    get isNct() {
        return this.__config.area === AREA_TYPE.NCT;
    }

    get isNcj() {
        return this.__config.area === AREA_TYPE.NCJ;
    }

    // 현재 망 정보 
    setEnv() {
        const subdomain = {
            opdev: ['op.', 'opdev.', 'op-', 'opdev-', 'local.', 'localhost', 'ui-static', 'file:'],
            rc: ['rc.', 'rc-', 'rc2-'],
            sb: ['sb-', '.sb'],
        };
        let env = 'live';

        
        for (let prop in subdomain) {
            const matchs = subdomain[prop];
            const regexp = prop === 'sb' ? new RegExp(`^http[s]?:\\/\\/sb-|.sb+.*`, 'i') : new RegExp(`^http[s]?:\\/\\/(${matchs.join('|')})+.*`, 'i');
            if (regexp.test(window.location.href)) {
                env = prop;
            }
        }

        this.__env = env;
    }

    // 권역별 staticHost 추출
    setStaticHostByArea(area = AREA_TYPE.NCK) {
        const cnbArea = AREA_TYPE.hasOwnProperty(area) ? area : AREA_TYPE.NCK;

        this.setEnv();
        this.__staticHost = this.__env ? STATIC_DOMAIN_MAP[cnbArea][this.__env] : '/';
    }

    // 플랫폼(퍼플 모바일앱(인앱))에 따른 link target 설정
    setLinkTarget(target) {
        const { isPurpleApp } = this.purpleCheck;
        return isPurpleApp ? '_self' : target;
    }

    // 플랫폼 다운로드 데이터 가공
    setPlatformDownloadData(originPlatformDownload = []) {
        let platformDownload = [];
        originPlatformDownload.forEach(v => {
            if(typeof v === 'string' && DOWNLOAD_PLATFORM.hasOwnProperty(v)) {
                platformDownload.push(DOWNLOAD_PLATFORM[v]);
            }
            if(typeof v === 'object' && (DOWNLOAD_PLATFORM.hasOwnProperty(v?.platform) || v?.url)) { // platform 없이 url, name 등이 있는 경우(ex. 공홈 내 다운로드 페이지)도 포함
                const defaultData = DOWNLOAD_PLATFORM.hasOwnProperty(v?.platform) ? DOWNLOAD_PLATFORM[v?.platform] : {};
                platformDownload.push({...defaultData, ...v});
            }
        });

        return platformDownload;
    }

    // 퍼플 디바이스 타입 체크
    getPurplePlatform() {
        const isPurple = this.purpleCheck.isPurple;
        const type = this.platform;

        return { isPurple, type: this.platform === PLATFORM.PURPLE.INAPP || this.platform === PLATFORM.PURPLE.WEBVIEW ? PLATFORM.PURPLE.APP : type};
    }
}